import styled from "styled-components";
import { Container } from "react-bootstrap";

export const BaseContainer = styled(Container)`
  margin: 0;
  padding: 0;
`;

export const PageInnerContainer = styled(BaseContainer)`
  padding: 10px;
`;

export const PageOuterContainer = styled(BaseContainer)`
  padding: 15px;
`;
